import React, { useState, useEffect, useContext, useRef } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import {
  Card,
  Stack,
  CardHeader,
  AppBar,
  Tabs,
  Tab,
  Autocomplete,
  TextField,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";

import MaterialBox from "../../components/MaterialBox";

import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import { useLoading } from "../../context/loading";
import { fetchAll } from "../../ApiBaseUrl";
import MaterialSelect from "../../components/MasterSelect";
import Swal from "sweetalert2";
import moment from "moment";
const RegularizationRequest = () => {
  const { circleLoading, setCirleLoading } = useLoading();
  const [regularizationList, setRegularizationList] = useState([]);
  const [notRegularization, setNotRegularization] = useState([]);
  const [tabValue, setTabValue] = useState("yet");
  const [branchList, setBranchList] = useState([]);
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [pop, setpop] = useState(false);
  const [leave, setLeave] = useState("");
  const [checkin, setCheckin] = useState("");
  const [checkout, setCheckout] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [checkinErr, setCheckinErr] = useState("unchecked");
  const [checkoutErr, setCheckoutErr] = useState("unchecked");
  const [selectedDayErr, setSelectedDayErr] = useState("unchecked");
  const [weekoff, setWeekOff] = useState([]);
  const [userid, setUserId] = useState("");
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [regularize, setRegularize] = useState({
    type: [],
    category: [],
    branch: [],
  });
  const [regularizedDate, setRegularizedDate] = useState("");
  const controllerRef = useRef(null);
  const typedata = [
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
  ];
  const emptype = [
    { value: "Staff", label: "Staff" },
    { value: "Operators", label: "Operators" },
  ];
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  // Getting user id from localstorage

  const user = JSON.parse(sessionStorage.getItem("user"));
  const getId = user?.[0]?.id;

  //onchange function
  const handelRegulariz = (e, type) => {
    const tempregularize = { ...regularize };
    const selectedtype = e;
    if (type == "emplyoType") {
      tempregularize["type"] = selectedtype.map((type) => type?.value);
    } else if (type == "emplyoCategory") {
      tempregularize["category"] = selectedtype.map((cate) => cate?.value);
    } else if (type == "Weekoffs") {
      if (e) {
        setSelectedDay(e);
        const filter = weekoff.find((item) => item?.date == e.value);
        setCheckin(filter?.checkIn);
        setCheckout(filter?.checkOut);
        setUserId(filter?.id);
        setCheckinErr("success");
        setCheckoutErr("success");
        setSelectedDayErr("success");
      } else {
        setCheckinErr("error");
        setCheckoutErr("error");
        setSelectedDayErr("error");
      }
    } else {
      tempregularize["branch"] = selectedtype.map((branch) => branch?.label);
    }
    setRegularize(tempregularize);
  };

  // handel change input
  const handleDateChange = (e) => {
    if (e?.target?.name == "fromDate") {
      setFromdate(e.target.value);
    } else if (e?.target?.name == "checkin") {
      if (e.target.value) {
        setCheckin(e.target.value);
        setCheckinErr("success");
      } else {
        setCheckinErr("error");
      }
    } else if (e?.target?.name == "checkout") {
      if (e.target.value) {
        setCheckout(e.target.value);
        setCheckoutErr("success");
      } else {
        setCheckoutErr("error");
      }
    } else {
      setTodate(e.target.value);
    }
  };

  // tabsvalueonchange
  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    if (newValue == "yet") {
      setRegularizationList([]);
    } else {
      setNotRegularization([]);
    }
    getRegularizationlist();
  };

  //disabled function
  const disabledSubmit = () => {
    let check = false;

    if (leave == "regularize") {
      if (checkinErr == "success" && checkoutErr == "success") {
        check = false;
      } else {
        check = true;
      }
    } else {
      if (
        checkinErr == "success" &&
        checkoutErr == "success" &&
        selectedDayErr == "success"
      ) {
        check = false;
      } else {
        check = true;
      }
    }
    return check;
  };

  // table data
  const pendingRegularizationListTable = {
    columns: [
      {
        field: "empid",
        headerName: "Employee Id",
        width: 120,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "empname",
        headerName: "Employee Name",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "branch",
        headerName: "Branch",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "emptype",
        headerName: "Employee Type",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "empcate",
        headerName: "Employee Category",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "date",
        headerName: "Date",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "checkin",
        headerName: "Check In Time",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "checkout",
        headerName: "Check Out Time",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "status",
        headerName: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: notRegularization.map((regularization) => ({
      id: regularization.id,
      empid: regularization?.user?.empid,
      empname:
        regularization?.user?.firstName + " " + regularization?.user?.lastName,
      branch: regularization?.user?.branch,
      date: formatDate(regularization?.requestedDate),
      emptype: regularization?.user?.employeeType,
      empcate: regularization?.user?.category,
      checkin:
        regularization?.checkIn == null
          ? "No Checkin"
          : moment(regularization.checkIn).format("hh:mm A"),
      checkout:
        regularization?.checkOut == null
          ? "No Checkout"
          : moment(regularization.checkOut).format("hh:mm A"),

      status: (
        <>
          {regularization?.checkIn == null &&
          regularization?.checkOut == null ? (
            <button
              style={{ backgroundColor: "red", outline: "none" }}
              onClick={() => {
                setpop(true);
                setLeave("absent");
                setCheckout("");
                setCheckin("");
                setSelectedDay("");
                setCheckinErr("unchecked");
                setCheckoutErr("unchecked");
                setSelectedDayErr("unchecked");
                getWeekoffdata(regularization?.user?.id);
                setId(regularization?.id);
              }}
            >
              Make as Lop
            </button>
          ) : (
            <button
              onClick={() => {
                setpop(true);
                setId(regularization?.id);
                setLeave("regularize");
                setCheckout("");
                setCheckin("");

                setCheckinErr("unchecked");
                setCheckoutErr("unchecked");
                setRegularizedDate(regularization?.requestedDate);
              }}
            >
              Regularize
            </button>
          )}
        </>
      ),
    })),
  };

  console.log(loading, "loading");

  const regularizationListTable = {
    columns: [
      {
        field: "empid",
        headerName: "Employee Id",

        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "empname",
        headerName: "Employee Name",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "branch",
        headerName: "Branch",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "emptype",
        headerName: "Employee Type",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "empcate",
        headerName: "Employee Category",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "checkin",
        headerName: "Check In Time",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "checkout",
        headerName: "Check Out Time",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "regularizedBy",
        headerName: "Regularizied By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "status",
        headerName: "Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: regularizationList.map((regularization) => ({
      id: regularization.id,
      empid: regularization?.user?.empid,
      empname:
        regularization?.user?.firstName + " " + regularization?.user?.lastName,
      branch: regularization?.user?.branch,
      emptype: regularization?.user?.employeeType,
      empcate: regularization?.user?.category,
      checkin:
        regularization?.checkIn == null
          ? "No Checkin"
          : moment(regularization.checkIn).format("hh:mm A"),
      checkout:
        regularization?.checkOut == null
          ? "No Checkout"
          : moment(regularization.checkOut).format("hh:mm A"),

      status: regularization?.status,
      regularizedBy: regularization?.regularizedBy?.firstName,
    })),
  };

  // api fetching

  // getlist

  const getRegularizationlist = async () => {
    setLoading(true);
    const query = `
   query MissingAttendanceEntries( 

  $branch: [String],  

  $category: [String],  

  $employeeType: [String] 

) { 

  missingAttendanceEntries( 

    branch: $branch 

    category: $category 

    employeeType: $employeeType 

  ) { 

    user { 

      id 

      username 

      empid 

      branch 

      category 

      employeeType 
firstName
lastName
    } 

    lastUpdate 

    requestedDate 

    checkIn 

    checkOut 

    reason 

    teamApproval 

    hrApproval 

    status 

    branch 

    employeeType 

    category 
    id
    regularizedBy{ 

      id 

      firstName 

    } 

  } 

} 
      `;

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the current request
    controllerRef.current = new AbortController();

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            branch: regularize?.branch,
            category: regularize?.category,
            employeeType: regularize?.type,
          },
        },
        { signal: controllerRef.current.signal },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = (await response?.data?.data?.missingAttendanceEntries) || [];

      const filteredData = data.filter((entry) => {
        const entryDate = entry.requestedDate;

        if (fromdate && todate) {
          return entryDate >= fromdate && entryDate <= todate;
        } else if (fromdate) {
          return entryDate >= fromdate;
        } else if (todate) {
          return entryDate <= todate;
        }
        return true;
      });

      setNotRegularization(
        filteredData.filter((item) => item?.status === "Pending")
      );
      setRegularizationList(
        filteredData.filter((item) => item?.status !== "Pending")
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getRegularizationlist();
  }, [regularize, fromdate, todate, tabValue]);

  // get branch data
  useEffect(() => {
    const fetchBranches = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        let result = data?.allBranch;
        let filterdata = result.map((val) => {
          return {
            value: val.id,
            label: val.name,
          };
        });
        setBranchList(filterdata);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);

  // get weekoff data
  const getWeekoffdata = async (id) => {
    setCirleLoading(true);
    const query = `
    query sundayAttendanceDetails($userId: String!) { 
    sundayAttendanceDetails(userId: $userId) { 
    id 
    checkIn 
    checkOut 
    totalWorkingHours 
    overtime 
  } 
}  `;
    const encodedId = btoa(id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { userId: "VXNlck5vZGU6" + encodedId },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data?.sundayAttendanceDetails?.map(
        (item) => ({
          id: item?.id,
          date: moment(item?.checkIn).format("YYYY-MM-DD"),
          checkIn: moment(item?.checkIn).format("HH:mm"),
          checkOut: moment(item?.checkOut).format("HH:mm"),
        })
      );

      setWeekOff(data);
    } catch (err) {
      console.log(err);
    } finally {
      setCirleLoading(false);
    }
  };

  //handelReject

  const handelReject = async () => {
    setCirleLoading(true);
    const reject = `
  mutation RegularizationApprovalReject($input: RegularizationApprovalRejectInput!) { 

  RejectRegularizationApproval(input: $input) { 

    regularizationApproval { 

      id 

      status 

      reason 

      teamApproval 

      hrApproval 

    } 

  } 

} 
  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: reject,
          variables: {
            input: {
              id: id,
              regularizedBy: getId,
            },
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      getRegularizationlist();
      console.log(response, "response");
      if (response?.data?.data?.RejectRegularizationApproval) {
        setpop("");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Regularization Rejected Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setCirleLoading(false);
    }
  };

  // acceptRegularization handelor
  const handelAccept = async () => {
    setCirleLoading(true);
    const reject =
      leave !== "absent"
        ? `
  mutation UpdateRegularizationApprovalforCheckinorOut($input: RegularizationApprovalUpdateInput!) { 

  updateRegularizationApproval(input: $input) { 

    regularizationApproval { 

      id 

      checkIn 

      checkOut 

      reason 

      teamApproval 

      hrApproval 

      status 

    } 

  } 

} 
  `
        : `mutation updateRegularizationforAbsent($input: RegularizationApprovalUpdateInput!, $attendanceId: ID) { 

  updateRegularizationApproval(input: $input, attendanceId: $attendanceId) { 

    regularizationApproval { 

      id 

      checkIn 

      checkOut 

      reason 

      teamApproval 

      hrApproval 

      status 

    } 

  } 

} `;
    const variables = {
      input:
        leave !== "absent"
          ? {
              id: id,
              checkIn: moment(
                `${regularizedDate} ${checkin}`,
                "YYYY-MM-DD HH:mm"
              ).format("YYYY-MM-DDTHH:mm:ss"),
              checkOut: moment(
                `${regularizedDate} ${checkout}`,
                "YYYY-MM-DD HH:mm"
              ).format("YYYY-MM-DDTHH:mm:ss"),
              regularizedBy: getId,
            }
          : {
              id: id,
              regularizedBy: getId,
            },
      attendanceId: userid,
    };

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: reject,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      getRegularizationlist();
      
      if(response?.data?.data?.updateRegularizationApproval?.regularizationApproval){
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Regularization Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }else{
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please Try Again Later",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setCirleLoading(false);
      setpop("");
    }
  };

  return (
    <DashboardLayout>
      {pop && (
        <Dialog
          maxWidth="sm"
          fullWidth
          // {...rest}
          open={true}
        >
          <DialogTitle>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                color: "#6a1b9a",
                fontSize: "0.95rem",
              }}
            >
              Regularization for Missing checkout
            </Typography>
          </DialogTitle>
          {leave == "absent" ? (
            weekoff?.length == 0 ? (
              <>
                <DialogContent variant="body2">
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                    padding={1}
                  >
                    <MaterialBox display="flex" textAlign="center">
                      <p style={{ color: "#888" }}>
                        No WeekOff data available.
                        <br />
                        If you click <b>'LOP'</b> button, the request will be
                        declined and the employee will be marked as absent.
                      </p>
                    </MaterialBox>
                  </Grid>
                </DialogContent>

                <DialogActions>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <MaterialButton
                        color="error"
                        variant="text"
                        onClick={() => setpop(false)}
                      >
                        Cancel
                      </MaterialButton>
                    </div>
                    <div>
                      <MaterialButton
                        color="success"
                        variant="text"
                        onClick={() => handelReject()}
                      >
                        LOP
                      </MaterialButton>
                    </div>
                  </div>
                </DialogActions>
              </>
            ) : (
              <>
                <DialogContent variant="body2">
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                    padding={1}
                  >
                    <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Weekoffs <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                      <MaterialSelect
                        name="Weekoffs"
                        value={selectedDay}
                        customStyles={{ optionPadding: 20 }}
                        options={weekoff?.map((value) => {
                          return {
                            value: value.date,
                            label: value.date,
                          };
                        })}
                        onChange={(e) => handelRegulariz(e, "Weekoffs")} //selectedValue, event
                        error={selectedDayErr === "error" ? true : false}
                        success={selectedDayErr === "success" ? true : false}
                        isClearable
                      />
                    </Grid>

                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Check In <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                      <MaterialInput
                        name="checkin"
                        type="time"
                        value={checkin}
                        onChange={handleDateChange}
                        inputProps={{
                          max: new Date().toISOString().split("T")[0],
                        }}
                        error={checkinErr === "error" ? true : false}
                        success={checkinErr === "success" ? true : false}
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Check Out <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                      <MaterialInput
                        name="checkout"
                        type="time"
                        value={checkout}
                        onChange={handleDateChange}
                        inputProps={{
                          max: new Date().toISOString().split("T")[0],
                        }}
                        error={checkoutErr === "error" ? true : false}
                        success={checkoutErr === "success" ? true : false}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>

                <DialogActions>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <MaterialButton
                        color="error"
                        variant="text"
                        onClick={() => setpop(false)}
                      >
                        Cancel
                      </MaterialButton>
                    </div>
                    <div>
                      <MaterialButton
                        color="success"
                        variant="text"
                        disabled={disabledSubmit()}
                        onClick={() => handelAccept()}
                      >
                        Accept
                      </MaterialButton>
                      <MaterialButton
                        color="success"
                        variant="text"
                        onClick={() => handelReject()}
                      >
                        LOP
                      </MaterialButton>
                    </div>
                  </div>
                </DialogActions>
              </>
            )
          ) : (
            <>
              <DialogContent variant="body2">
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                  padding={1}
                >
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Check In <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      name="checkin"
                      type="time"
                      value={checkin}
                      onChange={handleDateChange}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                      error={checkinErr === "error" ? true : false}
                      success={checkinErr === "success" ? true : false}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Check Out <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      name="checkout"
                      type="time"
                      value={checkout}
                      onChange={handleDateChange}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                      error={checkoutErr === "error" ? true : false}
                      success={checkoutErr === "success" ? true : false}
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <MaterialButton
                      color="error"
                      variant="text"
                      onClick={() => setpop(false)}
                    >
                      Cancel
                    </MaterialButton>
                  </div>
                  <div>
                    <MaterialButton
                      color="success"
                      variant="text"
                      disabled={disabledSubmit()}
                      onClick={() => handelAccept()}
                    >
                      Accept
                    </MaterialButton>
                    <MaterialButton
                      color="success"
                      variant="text"
                      onClick={() => handelReject()}
                    >
                      LOP
                    </MaterialButton>
                  </div>
                </div>
              </DialogActions>
            </>
          )}
          {/* {weekoff?.length == 0 ? (
            <>
              <DialogContent variant="body2">
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                  padding={1}
                >
                  <MaterialBox display="flex" textAlign="center">
                    <p style={{ color: "#888" }}>
                      No WeekOff data available.
                      <br />
                      If you click <b>'Reject'</b> button, the request will be
                      declined and the employee will be marked as absent.
                    </p>
                  </MaterialBox>
                </Grid>
              </DialogContent>

              <DialogActions>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <MaterialButton
                      color="error"
                      variant="text"
                      onClick={() => setpop(false)}
                    >
                      Cancel
                    </MaterialButton>
                  </div>
                  <div>
                    <MaterialButton
                      color="success"
                      variant="text"
                      onClick={() => handelReject()}
                    >
                      Reject
                    </MaterialButton>
                  </div>
                </div>
              </DialogActions>
            </>
          ) : (
            <>
              <DialogContent variant="body2">
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                  padding={1}
                >
                  {leave == "absent" && (
                    <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Weekoffs <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                      <MaterialSelect
                        name="Weekoffs"
                        value={selectedDay}
                        customStyles={{ optionPadding: 20 }}
                        options={weekoff?.map((value) => {
                          return {
                            value: value.date,
                            label: value.date,
                          };
                        })}
                        onChange={(e) => handelRegulariz(e, "Weekoffs")} //selectedValue, event
                        error={selectedDayErr === "error" ? true : false}
                        success={selectedDayErr === "success" ? true : false}
                        isClearable
                      />
                    </Grid>
                  )}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Check In <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      name="checkin"
                      type="time"
                      value={checkin}
                      onChange={handleDateChange}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                      error={checkinErr === "error" ? true : false}
                      success={checkinErr === "success" ? true : false}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Check Out <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      name="checkout"
                      type="time"
                      value={checkout}
                      onChange={handleDateChange}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                      error={checkoutErr === "error" ? true : false}
                      success={checkoutErr === "success" ? true : false}
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <MaterialButton
                      color="error"
                      variant="text"
                      onClick={() => setpop(false)}
                    >
                      Cancel
                    </MaterialButton>
                  </div>
                  <div>
                    <MaterialButton
                      color="success"
                      variant="text"
                      disabled={disabledSubmit()}
                      onClick={() => handelAccept()}
                    >
                      Accept
                    </MaterialButton>
                    <MaterialButton
                      color="success"
                      variant="text"
                      onClick={() => handelReject()}
                    >
                      Reject
                    </MaterialButton>
                  </div>
                </div>
              </DialogActions>
            </>
          )} */}
        </Dialog>
      )}
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Regularization List
                </MaterialTypography>
              </Stack>
              <MaterialBox alignItems="center" width="60%">
                <MaterialBox width="80%">
                  <AppBar position="static">
                    <Tabs
                      // orientation={tabsOrientation}
                      value={tabValue}
                      onChange={handleSetTabValue}
                      sx={{ backgroundColor: "transparent" }}
                    >
                      <Tab label="Yet To Regularize" value="yet" />
                      <Tab label="Regularized" value="regularized" />
                    </Tabs>
                  </AppBar>
                </MaterialBox>
              </MaterialBox>
            </Stack>
          }
        />
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={1}
          padding={1}
        >
          <Grid size={{ xs: 6, sm: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Branch <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <Autocomplete
              multiple
              options={branchList}
              value={regularize?.branch.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) =>
                handelRegulariz(newValue, "branch")
              }
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple days"
                />
              )}
              isSuccess={true}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Employee Type <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <Autocomplete
              multiple
              options={emptype}
              value={regularize?.type?.map((day) => ({
                value: day,
                label: day,
              }))} // Map state values back to objects
              onChange={(event, newValue) =>
                handelRegulariz(newValue, "emplyoType")
              }
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              // disabled={togglePage.view === true ? true : false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple days"
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Employee Category <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <Autocomplete
              multiple
              options={typedata}
              value={regularize?.category.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) =>
                handelRegulariz(newValue, "emplyoCategory")
              }
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              // disabled={togglePage.view === true ? true : false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple days"
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                From
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="fromDate"
              type="date"
              value={fromdate}
              onChange={handleDateChange}
              inputProps={{
                max: new Date().toISOString().split("T")[0],
              }}
            />
          </Grid>
          <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                To
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="todate"
              type="date"
              value={todate}
              onChange={handleDateChange}
              inputProps={{
                min: fromdate,
                max: new Date().toISOString().split("T")[0],
              }}
            />
          </Grid>
        </Grid>
        {tabValue == "yet" ? (
          <MaterialDataGrid
            rows={pendingRegularizationListTable.rows}
            columns={pendingRegularizationListTable?.columns}
            checkboxSelection={false}
            isSelectable={false}
            loading={loading}
            noSearch={true}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No regularization found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet added any regularization details. Click on
                    the "Add regularization" button to start adding
                    regularization details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        ) : (
          <MaterialDataGrid
            rows={regularizationListTable.rows}
            columns={regularizationListTable.columns}
            checkboxSelection={false}
            isSelectable={false}
            loading={loading}
            noSearch={true}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No regularization found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet added any regularization details. Click on
                    the "Add regularization" button to start adding
                    regularization details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}
      </Card>
    </DashboardLayout>
  );
};

export default RegularizationRequest;
